import React from 'react';

import { Col, Row } from 'antd';

import GenerateContentIcon from '../../../resources/icons/ai/GenerateContentIcon';
import { colorPalette } from '../../../resources/styles/colorPalette';

import FlagCountrySection from '../mainPagesLists/FlagCountrySection';

const classes = {
    titleWrapper: 'ant-modal-title ai-optimizer-modal-header',
    keywordWrapper: 'keyword-wrapper',
};

const AiOptimizerModalHeader = ({
    keyword = '',
    language_code = '',
    country_code = '',
    location = null,
    title = 'AI Optimizer Options',
}) => {
    return (
        <>
            <Row wrap={false} justify='center' align='top'>
                <Col flex='30px'>
                    <GenerateContentIcon color={colorPalette.colorPrimary} />
                </Col>
                <Col flex='auto'>
                    <div className={classes.titleWrapper}>{title}</div>
                    <div className={classes.keywordWrapper}>
                        <span>{keyword}</span>
                        <FlagCountrySection
                            countryCode={country_code}
                            languageCode={language_code}
                            concreteLocation={location}
                        />
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default AiOptimizerModalHeader;
